import { useLocation } from 'react-router-dom';

export const queryUrl = (key: string, value: string | number | null, currentSearch?: string) => {
  const search = new URLSearchParams(currentSearch);
  if (typeof value === 'string') {
    search.set(key, value);
  } else if (typeof value === 'number') {
    search.set(key, value.toString());
  } else {
    search.delete(key);
  }
  return `?${search.toString()}`;
};

type Args1 = [key: string, value: string | null];
type Args2 = [values: Record<string, string | null>];

const isArgs1 = (args: Args1 | Args2): args is Args1 => typeof args[0] === 'string';

export function useQueryUrl(key: string, value: string | null): string;
export function useQueryUrl(values: Record<string, string | null>): string;

export function useQueryUrl(...args: Args1 | Args2): string {
  const location = useLocation();
  let search = location.search;

  if (isArgs1(args)) {
    const key = args[0];
    const value = args[1] as string | null;

    return queryUrl(key, value, search);
  } else {
    const values = args[0];

    for (const [key, value] of Object.entries(values)) {
      search = queryUrl(key, value, search);
    }
    return search;
  }
}
